/**
 * Mirror of backend/src/core/auth/username.ts — there is no module shared
 * between backend/ and frontend/, so the literal is duplicated. Neither suite
 * can read the other tree (app-fe mounts only frontend/), so both username.test
 * files pin the same written-out literal instead; editing the rule on one side
 * fails that side's guard, which is the cue to edit the other.
 */
export const USERNAME_RE = /^[a-zA-Z0-9_-]+(?: [a-zA-Z0-9_-]+)?$/;
export const USERNAME_MIN = 3;
export const USERNAME_MAX = 32;

/** The register form's `pattern` attribute, derived so it cannot drift. */
export const USERNAME_PATTERN = USERNAME_RE.source.replace(/^\^|\$$/g, '');

/** The register form is `novalidate`, so this is the only client-side check. */
export function usernameError(raw: string): string | null {
  if (!raw) return null; // username is optional at signup
  if (raw.length < USERNAME_MIN || raw.length > USERNAME_MAX) {
    return `Username must be ${USERNAME_MIN}–${USERNAME_MAX} characters.`;
  }
  if (!USERNAME_RE.test(raw)) {
    return 'Username may contain letters, digits, _ and -, with at most one space between words.';
  }
  return null;
}
